// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"403":"72145552","670":"1a3fdf3d"}[chunkId] + ".chunk.js";
};